export default "__VITE_ASSET__DC8DUaCe__"